import { render, staticRenderFns } from "./memberTable.vue?vue&type=template&id=134fbd8e"
import script from "./memberTable.vue?vue&type=script&lang=js"
export * from "./memberTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports